import { CustomModel, CustomModelFormValues } from "../types";
import { UseFormReturn } from "react-hook-form";
import { useState } from "react";
import { useCustomParametersStore } from "../CustomModelsCreation/CustomParameters/custom-parameters-store";

export const useCustomModelsControls = ({
  setIsConfirmationModalOpen,
  methods,
}: {
  setIsConfirmationModalOpen: (isConfirmationModalOpen: boolean) => void;
  methods: UseFormReturn<CustomModelFormValues>;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const store = useCustomParametersStore();

  const onEditModel = (model: CustomModel, isViewing?: boolean) => {
    methods.setValue(
      "create_custom_model",
      {
        provider: model.provider_name,
        modelName: model.llm_model_name,
        displayName: model.display_name ?? "",
        modelType: model.is_chat ? "chat" : "completion",
        apiKey: "********",
        id: model.id,
      },
      {
        shouldDirty: true,
      },
    );
    store.setSavedParameters(model.params);
    setIsOpen(true);
    isViewing ? store.setIsViewing(true) : store.setIsEditing(true);
  };

  const onOpenChange = (isOpen: boolean) => {
    if (!isOpen && !store.isViewing && store.areParametersDifferent) {
      setIsConfirmationModalOpen(true);

      return;
    }

    setIsOpen(isOpen);

    if (!isOpen) {
      methods.reset();
      setActiveStep(0);
      store.reset();
      store.isViewing ? store.setIsViewing(false) : store.setIsEditing(false);
    }
  };

  return {
    onEditModel,
    onOpenChange,
    isOpen,
    setIsOpen,
    activeStep,
    setActiveStep,
  };
};
